import "react-app-polyfill/ie11";
import React from "react";
import PropTypes from "prop-types";
import { ProgressBar } from "@domestika-dev/prudencio/dist/atoms/ProgressBar";
import { Box } from "@domestika-dev/prudencio/dist/atoms/Layout";

const CourseUnitPage = ({ progress }) => (
  // TODO: When we update a design sys in Prudencio, remove the personalitation hardcoded
  // TODO: Esto debería de ser la vista donde se pinta toooda la unidad, y no acabar en un partial donde se llama como si fuera un componente,
  // pero react_rails espera los componentes dentro de views por default así que de momento simularemos que esto es un componente hasta que podamos
  // hacer toda la vista aquí dentro, con su correspondiente fiesta
  // DE HECHO YA EXISTE EL COMPONENTE DE COVER DE VIDEO CON PLAY Y PROGRESS BAR, HAY QUE MIRGRARLO
  <Box position="absolute" bottom={0} width="100%" height="5px">
    <ProgressBar percent={progress} size="small" isTransparent />
  </Box>
);

CourseUnitPage.propTypes = {
  progress: PropTypes.number,
};

CourseUnitPage.defaultProps = {
  progress: 0,
};

export default CourseUnitPage;
